import React from "react";
import { useState } from "react";
import {
  createInitialForm,
  validateRequiredField,
} from "../../../common/common";
import { adminLoginData } from "../../../assets/lib/login";
import { COLLECTION, SESSION } from "../../../data/constant";
import {
  Timestamp,
  addDoc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../config/firebase";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routing/routes";
import Layout from "./Layout";

const AdminLogin = () => {
  const [loginState, setLoginState] = useState(createInitialForm(adminLoginData));
  const [loginFailedText, setLoginFailedText] = useState("");
  const [errorFields, setErrorFields] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);

  const navigate = useNavigate();

  const getLoginInput = (event) => {
    const name = event.target.name;
    let value = event.target.value;
    const inputType = event.target.type;
    if (value && inputType === "number") {
      value = parseInt(value);
    }
    if (errorFields.includes(name) && ![undefined, null, ""].includes(value)) {
      setErrorFields((prevState) => prevState.filter((key) => key !== name));
    }
    setLoginState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleLogin = async () => {
    const error = validateRequiredField(adminLoginData, loginState);
    setErrorFields(error);

    if (error.length === 0) {
      try {
        setSubmitLoading(true);
        const collectionRef = collection(db, COLLECTION.ADMIN);
        const baseQuery = query(
          collectionRef,
          where("email", "==", loginState.email)
        );
        const querySnapshot = await getDocs(baseQuery);

        if (!querySnapshot.empty) {
          const docSnap = querySnapshot.docs[0];
          const docData = { ...docSnap.data(), id: docSnap.id };
          if (docData.password === loginState.password) {
            // setLoginFailedText("Login successfull");
            const sessionCollectionRef = collection(
              db,
              COLLECTION.ADMIN_SESSION
            );
            const addedDocRef = await addDoc(sessionCollectionRef, {
              email: docData.email,
              sessionStart: Timestamp.now(),
              adminId: docData.id,
            });
            setSubmitLoading(false);
            localStorage.setItem(SESSION.ADMIN_SESSION_ID, addedDocRef.id);
            navigate(routes.DASHBOARD);
          } else {
            setSubmitLoading(false);
            setLoginFailedText("Incorrect Password");
          }
        } else {
          setSubmitLoading(false);
          setLoginFailedText("No email id found");
        }
      } catch (error) {
        setSubmitLoading(false);
        console.log("error", error);
      }
    }
  };

  return (
    <Layout
      loginState={loginState}
      loginFailedText={loginFailedText}
      errorFields={errorFields}
      getLoginInput={getLoginInput}
      handleLogin={handleLogin}
    />
  );
};

export default AdminLogin;
